import { useEffect, useRef, useState } from 'react';
import { padNumber } from '../../utils/numberUtils/padNumber';
import { millisecondsToSeconds, minutesToHours, secondsToMinutes } from './utils/timeUtils';

/**
 * Хук для получения времени, оставшегося до переданной даты
 * @param timeEnd дата (в UNIX) до которой нужно производить отсчет
 * @param onEnd опциональный коллбек для вызова при завершении отсчета
 * @returns строка в формате hh:mm:ss
 */
export const useCountdown = (timeEnd: number, onEnd?: () => void) => {
    const timeDiff = useRef(0);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);
    const [ timeLeft, setTimeLeft ] = useState('');

    useEffect(() => {
        clearTimer();

        const difference = millisecondsToSeconds(timeEnd - Date.now() - 1);
        if (difference <= 0) return;
        timeDiff.current = difference;

        intervalRef.current = setInterval(() => {
            setTimeLeft(parseTimeLeft(timeDiff.current));
            timeDiff.current = timeDiff.current - 1;
            if (timeDiff.current === -1) {
                clearTimer();
                onEnd && onEnd();
            }
        }, 1000);
    }, [ timeEnd ]);

    const parseTimeLeft = (seconds: number) => {
        const minutes = secondsToMinutes(seconds);
        const hours = minutesToHours(minutes);

        return `${padNumber(hours, 2)}:${padNumber(minutes % 60, 2)}:${padNumber(seconds % 60, 2)}`;
    };

    const clearTimer = () => {
        intervalRef.current && clearInterval(intervalRef.current);
    };

    return timeLeft;
};
